import { formatDateReadable } from '@nemuru-eng/js-api-client';

import { ReportsListRowProps } from '@/components/modules/Reports/ReportsList/types/ReportsListRowProps';

import { useCustomTheme } from '../../../../../../../hooks/useCustomTheme';
import { Text } from '../../../../../../shared/components/Text';

export const reportDateAndReferenceMobileFieldColumn = ({ flex }: { flex?: number }) => {
  const { palette } = useCustomTheme();
  return {
    flex: flex ?? 0.4,
    field: 'report_date',
    headerName: <Text tId={'REPORT_DATE'} />,
    align: 'left',
    searchable: false,
    defaultSort: 'desc',
    renderCell: (rowData: ReportsListRowProps) => {
      return (
        <div
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              color: palette.text.primary,
            }}
          >
            <strong>{formatDateReadable(rowData.row.reportDate)}</strong>
          </div>
          <span color={palette.text.secondary}>{rowData.row.businessName}</span>
        </div>
      );
    },
  };
};
